<template>
    <div>
        <el-card>
            <div slot="header" class="clearfix">
                <span class="table-title">今日数据</span>
            </div>
            <div class="welcome-list">
                <div>
                    <p class="welcome-title" style="color:#b03839">新增用户</p>
                    <p class="welcome-blue" style="color:#b03839">{{indexList.today_register_user}}</p>
                </div>
                <div>
                    <p class="welcome-title" style="color:#409eff;">充值用户</p>
                    <p class="welcome-blue">{{indexList.today_charge_user}}</p>
                </div>
                <div>
                    <p class="welcome-title" style="color:#409eff;">充值订单</p>
                    <p class="welcome-blue">{{indexList.today_charge_num}}</p>
                </div>
                <div>
                    <p class="welcome-title" style="color:#409eff;">充值金额</p>
                    <p class="welcome-blue">${{indexList.today_charge_money}}</p>
                </div>
                <div>
                    <p class="welcome-title" style="color: #f9b90c;">VIP充值用户</p>
                    <p class="welcome-blue" style="color: #f9b90c;">{{indexList.today_vip_user}}</p>
                </div>
                <div>
                    <p class="welcome-title" style="color: #f9b90c;">VIP充值订单</p>
                    <p class="welcome-blue" style="color: #f9b90c;">{{indexList.today_vip_num}}</p>
                </div>
                <div>
                    <p class="welcome-title" style="color: #f9b90c;">VIP充值金额</p>
                    <p class="welcome-blue" style="color: #f9b90c;">${{indexList.today_vip_money}}</p>
                </div>
            </div>
        </el-card>

        <el-card>
            <div slot="header" class="clearfix">
                <span class="table-title">数据总览</span>
            </div>
            <div class="welcome-list">
                <div>
                    <p class="welcome-title">总用户数</p>
                    <p class="welcome-blue">{{indexList.total_register_user}}</p>
                </div>
                <div>
                    <p class="welcome-title">充值用户</p>
                    <p class="welcome-blue">{{indexList.total_charge_user}}</p>
                </div>
                <div>
                    <p class="welcome-title">充值订单</p>
                    <p class="welcome-blue">{{indexList.total_charge_num}}</p>
                </div>
                <div>
                    <p class="welcome-title">充值金额</p>
                    <p class="welcome-blue">${{indexList.total_charge_money}}</p>
                </div>
                <div>
                    <p class="welcome-title">VIP充值用户</p>
                    <p class="welcome-blue">{{indexList.total_vip_user}}</p>
                </div>
                <div>
                    <p class="welcome-title">VIP充值订单</p>
                    <p class="welcome-blue">{{indexList.total_vip_num}}</p>
                </div>
                <div>
                    <p class="welcome-title">VIP充值金额</p>
                    <p class="welcome-blue">${{indexList.total_vip_money}}</p>
                </div>
            </div>
        </el-card>
        <div class="eacharts-box">
            <el-card>
                <div slot="header" class="clearfix">
                    <span class="table-title">新增用户数据</span>
                </div>
                <div ref="main" class="echarts"></div>
            </el-card>
            <el-card>
                <div slot="header" class="clearfix">
                    <span class="table-title">充值数据</span>
                </div>
                <div ref="bar" class="echarts"></div>
            </el-card>
              <el-card>
                <div slot="header" class="clearfix">
                    <span class="table-title">VIP充值数据</span>
                </div>
                <div ref="vip" class="echarts"></div>
            </el-card>
        </div>

        <el-card>
            <div slot="header" class="clearfix">
                <span class="table-title">最近一个月数据统计</span>
                <el-button type="primary" @click="exportToExcel()" style="margin-left:20px;" class="el-icon-s-marketing"> 导出excel </el-button>
            </div>
            <el-table
                    size="small"
                    :data="tableData"
                    border
                    style="width: 100%;text-align: center;">
                <el-table-column
                        type="index"
                        label="#">
                </el-table-column>
                <el-table-column
                        prop="date"
                        label="日期">
                </el-table-column>
                <el-table-column
                        prop="register_user"
                        label="新增用户">
                </el-table-column>
                <el-table-column
                        prop="charge_money"
                        label="充值金额">
                </el-table-column>
                <el-table-column
                        prop="charge_total_num"
                        label="支付订单数">
                </el-table-column> 
                <el-table-column
                        prop="charge_pay_num"
                        label="充值成功数">
                </el-table-column>
                <el-table-column
                        prop="charge_rate%"
                        label="充值成功率">
                    <template slot-scope="scope">
                        <!-- <p>支付订单：{{scope.row.charge_total_num}} </p>
                        <p>充值成功：{{scope.row.charge_pay_num}}</p> -->
                        <p>{{scope.row.charge_rate}}%</p>
                    </template>
                </el-table-column>

                <el-table-column
                        prop="vip_money"
                        label="VIP充值金额">
                </el-table-column>
                <el-table-column
                        prop="vip_num"
                        label="VIP订单数">
                </el-table-column>
                <el-table-column
                      prop="vip_pay_num"
                      label="VIP支付成功数">
                </el-table-column>
                <el-table-column
                      prop="vip_rate"
                      label="VIP充值成功率">
                       <template slot-scope="scope">
                          <p>{{scope.row.vip_rate}}%</p>
					   </template>
                </el-table-column>
            </el-table>
        </el-card>
    </div>
</template>

<script>
  export default {
    name: "Welcome",
    data() {
      return {
        tableData: [],
        indexList: [],
      }
    },
    mounted() {
      this.PostIndex()

    },
    methods: {
      PostIndex() {
        this.$axios.post('admin/main/index')
          .then(res => {
            //console.log(res.data);
            this.indexList = res.data
            this.tableData = res.data.use_withdraw_charge_data
            this.getList(res.data.user_register_data)
            this.barClick(res.data.user_charge_data)
            this.getVip(res.data.user_vip_data)
          })
      },
      //导出数据
      exportToExcel(){
        //excel数据导出
        require.ensure([],()=>{
            const{
              export_json_to_excel
            } = require('../excel/Export2Excel');
            const tHeader = ['日期','新增用户','充值金额','支付订单数','充值成功数','充值成功率','VIP充值金额','VIP订单数','VIP支付成功数','VIP充值成功率'];
            const filterVal = ['date','register_user','charge_money','charge_total_num','charge_pay_num','charge_rate','vip_money','vip_num','vip_pay_num','vip_rate'];
            const list = this.tableData;
            const data = this.formatJson(filterVal,list);
            export_json_to_excel(tHeader,data,'最近一个月数据统计_excel');
        })
      },
      formatJson(filterVal,jsonData){
          return jsonData.map(v => filterVal.map(j => v[j]));
      },
      // 折线图
      getList(e) {
        var date = []
        var iOS_data = []
        var Android_data = []
        e.forEach(item => {
          date.push(item.date)
          iOS_data.push(item.iOS)
          Android_data.push(item.Android)
        })
        var myChart = this.$echarts.init(this.$refs.main);
        let option = {
          tooltip: {
            trigger: 'axis'
          },
          legend: {},
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: date,
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: 'Android',
              type: 'line',
              data: Android_data,
            },
            {
              name: 'iOS',
              type: 'line',
              data: iOS_data
            }
          ]
        };
        myChart.setOption(option);
      },
      // 曲线图
      barClick(e) {
        var date = []
        var iOS_data = []
        var Android_data = []
        e.forEach(item => {
          date.push(item.date)
          iOS_data.push(item.iOS)
          Android_data.push(item.Android)
        })
        var myChart = this.$echarts.init(this.$refs.bar);
        //console.log(myChart);
        let option = {
          tooltip: {
            trigger: 'axis'
          },
          legend: {},
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: date
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: 'Android',
              type: 'line',
              smooth: true,
              data: Android_data,
            },
            {
              name: 'iOS',
              type: 'line',
              smooth: true,
              data: iOS_data
            },
          ]
        };

        myChart.setOption(option);
      },
      //vip曲线
      getVip(e){
        var date = [];
        var iOS_data_vip = [];
        var Android_data_vip = [];
        e.forEach(item =>{
          date.push(item.date)
          iOS_data_vip.push(item.iOS)
          Android_data_vip.push(item.Android)
        })
        var myChart = this.$echarts.init(this.$refs.vip);
        //console.log(myChart);
          let option = {
              tooltip: {
                trigger: 'axis'
              },
              legend: {},
              grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
              },
              toolbox: {
                feature: {
                  saveAsImage: {}
                }
              },
              xAxis: {
                type: 'category',
                boundaryGap: false,
                data: date
              },
              yAxis: {
                type: 'value'
              },
              series: [
                {
                  name: 'Android',
                  type: 'line',
                  smooth: true,
                  data: Android_data_vip,
                },
                {
                  name: 'iOS',
                  type: 'line',
                  smooth: true,
                  data: iOS_data_vip
                },
              ]
          };
        myChart.setOption(option);
      }
    }
  }
</script>

<style scoped lang="less">
    @media screen and (max-width: 750px) {
        .welcome-list {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            flex-direction: row;
            justify-content: space-between;

            > div {
                text-align: center;
                width: 100px;
                margin-bottom: 20px;
            }
        }

        .eacharts-box {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;

            .el-card {
                width: 100%;
            }
        }
    }

    @media screen and (min-width: 750px) {
        .welcome-list {
            display: flex;
            align-items: center;
            justify-content: space-between;

            > div {
                text-align: center;
                width: 14%;
            }
        }

        .eacharts-box {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;

            .el-card {
                width: 49%;
            }
        }
    }
    .cell{
      line-height:50px !important;
      text-align: center !important;
    }
    .table-title {
        font-weight: bold;
        font-size: 18px;
    }

    .echarts {
        height: 300px;
        width: 100%;
    }


    .welcome-title {
        font-size: 20px;
        margin-bottom: 25px;
        color: #0A1C33;
    }

    .welcome-blue {
        color: #409EFF;
        font-size: 26px;
    }
</style>